export interface ICheckoutPageProps {}

const CheckoutPage: React.FunctionComponent<ICheckoutPageProps> = (props) => {
  return <p>This is the checkout page.</p>;
};

export { CheckoutPage };
